import "./App.css";
import Login from "./Login/Login";
import { experimental_extendTheme as materialExtendTheme, Experimental_CssVarsProvider as MaterialCssVarsProvider, THEME_ID as MATERIAL_THEME_ID } from "@mui/material/styles";
import { CssVarsProvider as JoyCssVarsProvider } from "@mui/joy/styles";
import React from "react";

import { extendTheme } from "@mui/joy/styles";
import "@fontsource/inter";
import { Route, Routes } from "react-router-dom";
import Logout from "./Login/Logout";
import Home from "./Pages/Home";
import Layout from "./Layout";
import TicketingPortal from "./Pages/TicketingPortal";
import BuildingPortal from "./Pages/BuildingPortal";
import UsersListing from "./Pages/UsersListing";
import CheckedInTracker from "./Pages/CheckedInTracker";
import InspectionsList from "./Pages/InspectionsList";
import FollowUps from "./Pages/FollowUps";
import BrokenElevators from "./Pages/BrokenElevators";
import UnapprovedPackingList from "./Pages/UnapprovedPackingLists";
import ApprovedPackingLists from "./Pages/ApprovedPackingLists";
import InspectionPortal from "./Pages/InspectionPortal";
import OutOfServiceElevators from "./Pages/OutOfServiceElevators";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ElevatorAds from "./Pages/ElevatorAds";
import AdRender from "./Pages/AdRender";
import ProposalsMissingBuilding from "./Pages/ProposalsMissingBuilding";
import ProposalsMissingElevator from "./Pages/ProposalsMissingElevator";
import PasswordChange from "./Login/PasswordChange";
const materialTheme = materialExtendTheme();

const theme = extendTheme({
	colorSchemes: {
		light: {
			palette: {
				background: {
					navMenu: "#282828",
				},
				primary: {
					50: "#2ca01c",
					100: "#2ca01c",
					200: "#2ca01c",
					300: "#2ca01c",
					400: "#2ca01c",
					500: "#2ca01c",
					600: "#2ca01c",
					700: "#2ca01c",
					800: "#2ca01c",
					900: "#2ca01c",
				},
			},
		},
	},
} as any);

function App() {
	const [loggedIn, setLoggedIn] = React.useState(document.cookie.includes("dynamicAuth"));
	const needsAuth = ["adrender","login","logout"].some(x => document.location.pathname.toString().includes(x));
	// if (!loggedIn && !document.location.pathname.toString().includes("login")) nav("/login");
	const authenticatedRoute = (
		<Routes>
			<Route path="/logout" element={<Logout />} />
			<Route path="/alltickets" element={<TicketingPortal selected={0} />} />
			<Route path="/recommendations" element={<TicketingPortal selected={1} />} />
			<Route path="/sales" element={<TicketingPortal selected={2} />} />
			<Route path="/outofservice" element={<TicketingPortal selected={3} />} />
			<Route path="/" element={<BuildingPortal />} />
			{/* <Route path="/" element={<Home />} /> */}
			<Route path="/buildingportal/*" element={<BuildingPortal />} />
			<Route path="/users" element={<UsersListing />} />
			<Route path="/checkedin" element={<CheckedInTracker />} />
			{/* <Route path="/inspections" element={<InspectionsList />} /> */}
			<Route path="/followups" element={<FollowUps />} />
			<Route path="/brokenelevators" element={<BrokenElevators />} />
			<Route path="/uaplists" element={<UnapprovedPackingList />} />
			<Route path="/aplists" element={<ApprovedPackingLists />} />
			<Route path="/1year" element={<InspectionPortal selected={0} />} />
			<Route path="/5year" element={<InspectionPortal selected={1} />} />
			<Route path="/alterations" element={<InspectionPortal selected={2} />} />
			{/* <Route path="/companies" element={<InspectionPortal selected={2} />} /> */}
			<Route path="/outofserviceelevators" element={<OutOfServiceElevators />} />
			<Route path="/elevatorads" element={<ElevatorAds />} />
			<Route path="/adrender" element={<AdRender />} />
			<Route path="/proposalsmissingbuilding" element={<ProposalsMissingBuilding />} />
			<Route path="/proposalsmissingelevator" element={<ProposalsMissingElevator />} />
		</Routes>
	);

	return (
		<LocalizationProvider dateAdapter={AdapterDateFns}>
			<MaterialCssVarsProvider theme={{ [MATERIAL_THEME_ID]: materialTheme }}>
				<JoyCssVarsProvider theme={theme}>{document.location.pathname.toLowerCase().includes("adrender") ? <AdRender /> : document.location.pathname.toLowerCase().includes("passwordchange") ? <PasswordChange /> : loggedIn ? <Layout>{authenticatedRoute}</Layout> : <Login onLogin={() => setLoggedIn(true)}></Login>}</JoyCssVarsProvider>
			</MaterialCssVarsProvider>
		</LocalizationProvider>
	);
}

export default App;
